import { reactive } from 'vue';

// 创建一个响应式状态对象
const state = reactive({
  showVerification: false,
  verificationData: null,
});

// 验证服务
const verificationService = {
  // 显示验证悬浮窗
  showVerification(data = null) {
    state.verificationData = data;
    state.showVerification = true;
  },
  
  // 隐藏验证悬浮窗
  hideVerification() {
    console.log("隐藏验证悬浮窗");
    
    state.showVerification = false;
  },
  
  // 获取状态
  getState() {
    return state;
  }
};

export default verificationService; 